import {
  DurationPickerV2,
  InfoPopover,
  Typography,
  useDurationPickerField,
} from '@automata/ui';

import { selectPlannerOptions } from '../../features/workflow/selectors';
import { updatePlannerOptions } from '../../features/workflow/workflowSlice';
import { useAppDispatch, useAppSelector } from '../../hooks';

export const MaxPlanningTimePicker = () => {
  const dispatch = useAppDispatch();
  const plannerOptions = useAppSelector(selectPlannerOptions);
  const maxComputationTime = plannerOptions?.max_computation_time ?? null;

  const { breakdown, handleBlur, handleUpdateTime } = useDurationPickerField(
    (newTotalSeconds: number) => {
      if (newTotalSeconds > 0) {
        dispatch(
          updatePlannerOptions({
            max_computation_time: newTotalSeconds,
          })
        );
      }
    },
    maxComputationTime
  );

  return (
    <DurationPickerV2
      label="Max planning time"
      infoPopover={
        <InfoPopover
          title="Max planning time"
          copy={
            <Typography variant="body2">
              This is maximum time the system will spend generating and
              optimizing a plan. If the timeout is reached before a valid plan
              is generated, planning will fail. <br /> <br />
              The maximum planning time is 5 minutes by default.
            </Typography>
          }
        />
      }
      hours={breakdown.hours}
      minutes={breakdown.minutes}
      seconds={breakdown.seconds}
      handleBlurParent={handleBlur}
      handleUpdateTime={handleUpdateTime}
    />
  );
};
